/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import SendApplication from "./SendApplication";
import TextContainer from "../../Container/TextContainer";
import { Helmet } from "react-helmet-async";
import Layout from "../../../containers/Layouts/Layout";
import Typography from "@mui/material/Typography";
import BenefitsLegalbirdTech from "./BenefitsLegalbirdTech";
import cvImage from "../../../assets/img/jobs/cv.svg";
import HeadlineSection from "../../Sections/Generic/HeadlineSection/HeadlineSection";
import MuiListNativeStyled from "../../List/MuiListNativeStyled";
import { gaSet } from "../../../services/googleAnalyticsService";

export default function SeniorDeveloper() {
  const title = "Jobs - Frontend Developer | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <HeadlineSection headline={"(Senior) Developer PHP/JS (m/w/d)"} image={cvImage} />
      <TextContainer sx={jobStyles.container}>
        <Typography>
          Mit unserer starken Onlinekompetenz, hoher juristischer Expertise und innovativer, AI-gestützter Automatisierung helfen wir dabei, rechtliche
          Fragestellungen sicher, schnell und professionell online zu lösen.
        </Typography>
        <Typography>
          Du hast Lust auf ein stark wachsendes Unternehmen und darauf, den Rechtsberatungsmarkt mit Hilfe modernster digitaler Technologien zu verändern? Du
          ziehst es vor, in einem produktiven Umfeld zu arbeiten, in dem Du Projekte selbstverantwortlich in die Hand nehmen kannst? Du schätzt eine offene
          Atmosphäre, in der es Spaß macht, über sich hinauszuwachsen? Dann bewirb Dich bei uns!
        </Typography>
      </TextContainer>
      <TextContainer sx={jobStyles.container}>
        <Typography variant={"h4"}>Was Deine Aufgaben sein werden</Typography>
        <MuiListNativeStyled
          sx={jobStyles.list}
          listItems={[
            "Du entwickelst die Legalbird Platform in PHP und Javascript",
            "Du setzt anspruchsvolle Aufgaben in modernen Frameworks (Symfony/React) um",
            "Du achtest dabei auf Qualität, Wartbarkeit und Lesbarkeit und denkst langfristig",
            "Du hast den kompletten Stack im Blick vom Frontend bis zum Deployment",
          ]}
        />
        <Typography variant={"h4"}>Was Du dazu brauchst</Typography>
        <MuiListNativeStyled
          sx={jobStyles.list}
          listItems={[
            "Du begeisterst Dich für das Thema Softwareentwicklung und Architektur",
            "Mehrjährige Berufserfahrung in der Software-Entwicklung (PHP/Javascript) und mindestens ein professionelles Projekt unter Einsatz eines modernen Frameworks.",
            "Wünschenswert sind Erfahrungen im Bereich Symfony (PHP) und React (JS)",
            "Du kommunizierst in enger Abstimmung mit unseren Produktmanagern und kannst neue Features auf technischer Ebene diskutieren, planen und auf Tasks herunterbrechen.",
            "Du liebst Herausforderungen in Deinem Bereich und brennst dafür, diese optimal und kreativ zu lösen",
          ]}
        />
        <BenefitsLegalbirdTech />
      </TextContainer>
      <SendApplication to={"Andreas Quauke"} />
    </Layout>
  );
}
